<script setup>
import { contacts } from '@/actions/App/Http/Controllers/PageController'
import { index as projectsIndex } from '@/actions/App/Http/Controllers/ProjectController'
</script>

<template>
    <section>
        <div class="absolute inset-0 z-20 flex flex-col items-center justify-center space-y-10">
            <div class="max-w-xl space-y-2 px-2 text-center lg:px-0 xl:max-w-2xl">
                <h1 class="font-chivo text-3xl leading-12 text-white lg:text-5xl">
                    Provádíme montáže sádrokartonu všeho druhu, foukané izolace a betonové stěrky.
                </h1>

                <h2 class="font-chivo hidden text-lg leading-12 text-white lg:block lg:text-xl">
                    „Dva kamarádi, které práce prostě baví!”
                </h2>
            </div>

            <div
                class="flex w-full max-w-xl flex-col items-center space-y-5 lg:flex-row lg:justify-center lg:space-y-0 lg:space-x-2"
            >
                <Link
                    :href="projectsIndex.url()"
                    aria-label="Přejít na stránku stavby"
                    class="bg-brand-orange border-brand-orange hover:bg-brand-orange/80 w-60 cursor-pointer rounded-full border px-5 py-4 text-center text-white backdrop-blur-3xl transition-all duration-150 ease-in-out lg:w-full xl:py-2"
                >
                    <span class="font-chivo text-center 2xl:text-3xl"> Stavby </span>
                </Link>

                <Link
                    :href="contacts.url() + '#kontaktni-formular'"
                    aria-label="Přejít na kontaktní formulář pro rezervaci"
                    class="border-brand-orange hover:bg-brand-orange w-60 cursor-pointer rounded-full border bg-black/30 px-5 py-4 text-center text-white backdrop-blur-3xl transition-all duration-150 ease-in-out lg:w-full xl:py-2"
                >
                    <span class="font-chivo text-center 2xl:text-3xl"> Sejít se </span>
                </Link>
            </div>
        </div>

        <div class="relative z-10">
            <img
                src="/src/imgs/obrazek_01.webp"
                alt="Pohled na J&M.Sádrokartony s.r.o."
                class="h-screen w-full object-cover brightness-40 filter"
            />
        </div>
    </section>
</template>
